import { PLATFORMS as PLATFORM } from "Constants/platforms";

import {ApiService, NotixApi, NotixApiService} from "Services/api";
import I18nService from "Services/i18n";
import { downloadFile, FILE_TYPES } from "../utils/downloadFile";
import { DIRECTION_LABELS } from "Services/zones";
import { isLastSevenDays } from "Services/time";
import Dayjs from "dayjs";

export const STATS_ADV_DATA = {
  PREREQUESTS: "prerequests",
  REQUESTS: "requests",
  IMPRESSIONS: "impressions",
  CLICKS: "clicks",
  CONVERSIONS: "conversions",
  SUBSCRIPTIONS: "subscriptions",
  MONEY: "money",
  CR: "cr",
  DATE_TIME: "date_time",
  ZONE_LABEL: "zone_label",
  ZONE_ID: "zone_id",
  SITE: "site_id",
  SITE_NAME: "url",
  COUNTRY_ID: "country_id",
  COUNTRY: "country",
  OS_ID: "os_id",
  OS: "os",
  REQUEST_VAR: "request_var",
  PUSH_ALREADY_SUBSCRIBED: "push_already_subscribed",
  PUSH_FIRST_IMPRESSIONS: "push_first_impressions",
  PUSH_UNSUBSCRIPTIONS: "push_unsubscriptions",
  CPM: "cpm",
  CTR: "ctr",
};

export const STATS_ADV_QUERY = {
  GROUP_BY: "group_by",
  DATE_FROM: "date_from",
  DATE_TO: "date_to",
  GEO: "geos",
  COUNTRIES: "countries",
  OSES: "oses",
  COUNTRY_ID: "country_id",
  OS_ID: "os_id",
  PLATFORMS: "platforms",
  ZONES: "zones",
  DIRECTIONS: "directions",
  SITES: "sites",
  REQUEST_VARS: "request_vars",
  TIME_ZONE: "tz",
};

export const STATS_DATA = {
  PREREQUESTS: "prerequests",
  REQUESTS: "requests",
  IMPRESSIONS: "impressions",
  CLICKS: "clicks",
  SUBSCRIPTIONS: "subscriptions",
  DAY: "day",
  ZONE: "zone",
  ZONE_LABEL: "zone_label",
  REQUEST_VAR: "request_var",
  PUSH_UNSUBSCRIPTIONS: "push_unsubscriptions",
  CTR: "ctr",
  COUNTRY_ID: "country_id",
  COUNTRIES: "countries",
  OS_ID: "os_id",
  OS: "os",
};

export const STATS_QUERY = {
  GROUP: "group",
  DAY_FROM: "day_from",
  DAY_TO: "day_to",
  ZONE: "zone",
  REQUEST_VAR: "request_var",
  OS: "os",
  TIME_ZONE: "tz",

  COUNTRIES: "countries",
  OSES: "oses",
  COUNTRY_ID: "country_id",
  OS_ID: "os_id",
};

export const DEFAULT_TIME_ZONE = "-0500";

function prepareDataToClient(array) {
  return array.map((item) => {
    return {
      value: item.id,
      label: item.title,
    };
  });
}

function prepareAdvDataToServer(array) {
  return array.map((item) => {
    return item.value;
  });
}

function prepareDataToServer(array) {
  return array
    .map((item) => {
      return item.value;
    })
    .toString();
}

export function getFieldAdvTitle(item) {
  switch (item) {
    case STATS_ADV_DATA.DATE_TIME:
      return I18nService.getStringByKey("stats_filters-date");
    case STATS_ADV_DATA.ZONE_ID:
      return I18nService.getStringByKey("stats_filters-zones");
    case STATS_ADV_DATA.SITE:
      return I18nService.getStringByKey("stats_filters-sites");
    case STATS_ADV_DATA.OS_ID:
      return I18nService.getStringByKey("stats_filters-os-type");
    case STATS_ADV_DATA.COUNTRY_ID:
      return I18nService.getStringByKey("stats_filters-country");
    case STATS_ADV_DATA.REQUEST_VAR:
      return I18nService.getStringByKey("stats_filters-message-id");
    case STATS_ADV_DATA.CTR:
      return I18nService.getStringByKey("stats_filters-ctr");
    default:
      return item;
  }
}

export function getFieldTitle(item) {
  switch (item) {
    case STATS_DATA.DAY:
      return I18nService.getStringByKey("stats_filters-date");
    case STATS_DATA.ZONE:
      return I18nService.getStringByKey("stats_filters-zones");
    case STATS_DATA.OS:
      return I18nService.getStringByKey("stats_filters-os-type");
    case STATS_DATA.COUNTRIES:
      return I18nService.getStringByKey("stats_filters-country");
    case STATS_DATA.REQUEST_VAR:
      return I18nService.getStringByKey("stats_filters-message-id");
    case STATS_DATA.CTR:
      return I18nService.getStringByKey("stats_filters-ctr");
    default:
      return item;
  }
}

function getPlatformTitle(platformId) {
  const platform = PLATFORM.find((os) => platformId === String(os.value));
  return platform ? platform.label : platformId;
}

function getPreparedStatsAdvData(query) {
  const params = {
    [STATS_ADV_QUERY.GROUP_BY]: query[STATS_ADV_QUERY.GROUP_BY],
    [STATS_ADV_QUERY.DATE_FROM]: query[STATS_ADV_QUERY.DATE_FROM],
    [STATS_ADV_QUERY.DATE_TO]: query[STATS_ADV_QUERY.DATE_TO],
    [STATS_ADV_QUERY.COUNTRY_ID]: prepareAdvDataToServer(query[STATS_ADV_QUERY.COUNTRIES]),
    [STATS_ADV_QUERY.OS_ID]: prepareAdvDataToServer(query[STATS_ADV_QUERY.OSES]),
    [STATS_ADV_QUERY.ZONES]: prepareAdvDataToServer(
      query[STATS_ADV_QUERY.ZONES]
    ),
    [STATS_ADV_QUERY.SITES]: prepareAdvDataToServer(
      query[STATS_ADV_QUERY.SITES]
    ),
    [STATS_ADV_QUERY.DIRECTIONS]: prepareAdvDataToServer(
      query[STATS_ADV_QUERY.DIRECTIONS]
    ),
    [STATS_ADV_QUERY.REQUEST_VARS]: prepareAdvDataToServer(
      query[STATS_ADV_QUERY.REQUEST_VARS]
    ),
  };
  if (
    query[STATS_ADV_QUERY.TIME_ZONE] !== DEFAULT_TIME_ZONE &&
    isLastSevenDays(query[STATS_ADV_QUERY.DATE_FROM])
  ) {
    params[STATS_ADV_QUERY.TIME_ZONE] = query[STATS_ADV_QUERY.TIME_ZONE];
  }

  return params;
}

function getPreparedStatsData(query) {
  return {
    [STATS_QUERY.GROUP]: query[STATS_QUERY.GROUP],
    [STATS_QUERY.DAY_FROM]: query[STATS_QUERY.DAY_FROM],
    [STATS_QUERY.DAY_TO]: query[STATS_QUERY.DAY_TO],
    [STATS_QUERY.COUNTRY_ID]: prepareDataToServer(query[STATS_QUERY.COUNTRIES]),
    [STATS_QUERY.ZONE]: prepareDataToServer(query[STATS_QUERY.ZONE]),
    [STATS_QUERY.REQUEST_VAR]: prepareDataToServer(
      query[STATS_QUERY.REQUEST_VAR]
    ),
    [STATS_QUERY.OS_ID]: prepareDataToServer(query[STATS_QUERY.OSES]),
  };
}

class Statistic {
  getFilters() {
    return ApiService.get("/stats/filters/").then((result) => {
      return {
        countries: prepareDataToClient([...result.countries,{id: 0, title: 'Unknown'}]),
        oses: prepareDataToClient([...result.oses, {id: 0, title: 'Unknown'}]),
        zone: prepareDataToClient(result.zones),
      };
    });
  }

  getGroupBy() {
    return [
      {
        value: STATS_DATA.DAY,
        id: STATS_DATA.DAY,
      },
      {
        value: STATS_DATA.ZONE,
        id: STATS_DATA.ZONE,
      },
      {
        value: STATS_DATA.COUNTRY_ID,
        id: STATS_DATA.COUNTRIES,
      },
      {
        value: STATS_DATA.REQUEST_VAR,
        id: STATS_DATA.REQUEST_VAR,
      },
      {
        value: STATS_DATA.OS_ID,
        id: STATS_DATA.OS,
      },
    ];
  }

  getStatistic(query, zoneLabel) {
    return NotixApi.get("/stats", {
      params: getPreparedStatsData(query),
    }).then((result) => {
      const { totals } = result;
      return {
        items: result.items.map((item) => {
          const newItem = {
            [STATS_DATA.PREREQUESTS]: item[STATS_DATA.PREREQUESTS],
            [STATS_DATA.REQUESTS]: item[STATS_DATA.REQUESTS],
            [STATS_DATA.IMPRESSIONS]: item[STATS_DATA.IMPRESSIONS],
            [STATS_DATA.CLICKS]: item[STATS_DATA.CLICKS],
            [STATS_DATA.SUBSCRIPTIONS]: item[STATS_DATA.SUBSCRIPTIONS],
            [STATS_DATA.PUSH_UNSUBSCRIPTIONS]:
              item[STATS_DATA.PUSH_UNSUBSCRIPTIONS],
            [STATS_DATA.CTR]: `${item[STATS_DATA.CTR].toFixed(2)} %`,
          };

          if (item[STATS_DATA.DAY]) {
            newItem[STATS_DATA.DAY] = item[STATS_DATA.DAY];
          }

          if (item[STATS_DATA.ZONE]) {
            newItem[STATS_DATA.ZONE] = item[STATS_DATA.ZONE];
            zoneLabel
              .filter((zone) => zone.value === item[STATS_DATA.ZONE] * 1)
              .map((f) => (newItem[STATS_DATA.ZONE_LABEL] = f.label));
          }

          if (item[STATS_DATA.COUNTRY_ID]) {
            newItem[STATS_DATA.COUNTRY_ID] = Number(item[STATS_DATA.COUNTRY_ID]);
          }

          if (item[STATS_DATA.OS_ID]) {
            newItem[STATS_DATA.OS_ID] = Number(item[STATS_DATA.OS_ID]);
          }

          newItem[STATS_DATA.REQUEST_VAR] =
            item[STATS_DATA.REQUEST_VAR] &&
            item[STATS_DATA.REQUEST_VAR].split("-").pop();

          return newItem;
        }),
        totals,
      };
    });
  }

  exportStatistic(query) {
    return NotixApi.get("/stats/export", {
      params: getPreparedStatsData(query),
    }).then((response) => {
      downloadFile(encodeURI(response.data) || "", "stats.csv", FILE_TYPES.STREAM);
    });
  }

  getAdvFilters() {
    return NotixApiService.get("/stats/adv/filters/").then((result) => {
      return {
        countries: prepareDataToClient(result.countries),
        oses: prepareDataToClient(result.oses),
        directions: prepareDataToClient(result.directions),
        zones: prepareDataToClient(result.zones),
        sites: prepareDataToClient(result.sites),
      };
    });
  }

  getAdvGroupBy() {
    const removeGroupByFields = [
      "zone_id",
      "geo",
      "platform",
      "direction_id",
      "publisher_site",
    ];

    return NotixApiService.get("/stats/adv/groups/").then((result) => {
      return result
        .map((item) => {
          return {
            value: item,
            id: item,
          };
        })
        .filter((item) => !["department"].includes(item.id))
        .filter((item) => !removeGroupByFields.includes(item.value));
    });
  }

  getAdvStatistic(query) {
    return NotixApiService.get("/stats/adv/", {
      params: getPreparedStatsAdvData(query),
    }).then((result) => {
      const { totals } = result;
      if (result.totals && result.totals[STATS_ADV_DATA.CPM]) {
        totals[STATS_ADV_DATA.CPM] = result.totals[STATS_ADV_DATA.CPM].toFixed(
          3
        );
      }

      return {
        items: result.items.map((item) => {
          const newItem = {
            [STATS_ADV_DATA.PREREQUESTS]: item[STATS_ADV_DATA.PREREQUESTS],
            [STATS_ADV_DATA.REQUESTS]: item[STATS_ADV_DATA.REQUESTS],
            [STATS_ADV_DATA.IMPRESSIONS]: item[STATS_ADV_DATA.IMPRESSIONS],
            [STATS_ADV_DATA.CLICKS]: item[STATS_ADV_DATA.CLICKS],
            [STATS_ADV_DATA.CONVERSIONS]: item[STATS_ADV_DATA.CONVERSIONS],
            [STATS_ADV_DATA.SUBSCRIPTIONS]: item[STATS_ADV_DATA.SUBSCRIPTIONS],
            [STATS_ADV_DATA.MONEY]: `${item[STATS_ADV_DATA.MONEY]
              .toFixed(3)
              ?.replace(/\.?0+$/, "")} $`,
            [STATS_ADV_DATA.CR]: item[STATS_ADV_DATA.CR],
            [STATS_ADV_DATA.PUSH_UNSUBSCRIPTIONS]:
              item[STATS_ADV_DATA.PUSH_UNSUBSCRIPTIONS],
            [STATS_ADV_DATA.PUSH_FIRST_IMPRESSIONS]:
              item[STATS_ADV_DATA.PUSH_FIRST_IMPRESSIONS],
            [STATS_ADV_DATA.PUSH_ALREADY_SUBSCRIBED]:
              item[STATS_ADV_DATA.PUSH_ALREADY_SUBSCRIBED],
          };

          if (item[STATS_ADV_DATA.CPM] || item[STATS_ADV_DATA.CPM] === 0) {
            newItem[STATS_ADV_DATA.CPM] = item[STATS_ADV_DATA.CPM].toFixed(3);
          }

          if (item[STATS_ADV_DATA.DATE_TIME]) {
            newItem[STATS_ADV_DATA.DATE_TIME] = item[STATS_ADV_DATA.DATE_TIME];
          }

          if (item[STATS_ADV_DATA.ZONE_LABEL]) {
            newItem[STATS_ADV_DATA.ZONE_LABEL] =
              item[STATS_ADV_DATA.ZONE_LABEL];
          }

          if (item[STATS_ADV_DATA.ZONE_ID]) {
            newItem[STATS_ADV_DATA.ZONE_ID] = item[STATS_ADV_DATA.ZONE_ID];
          }

          if (item[STATS_ADV_DATA.SITE]) {
            newItem[STATS_ADV_DATA.SITE] = item[STATS_ADV_DATA.SITE];
          }

          if (item[STATS_ADV_DATA.SITE_NAME]) {
            newItem[STATS_ADV_DATA.SITE_NAME] = decodeURIComponent(atob(item[STATS_ADV_DATA.SITE_NAME]));
          }



          if (item[STATS_ADV_DATA.COUNTRY]) {
            newItem[STATS_ADV_DATA.COUNTRY] = item[STATS_ADV_DATA.COUNTRY];
          } else {
            newItem[STATS_ADV_DATA.COUNTRY] = "Unknown country"
          }


          if (item[STATS_ADV_DATA.OS]) {
            newItem[STATS_ADV_DATA.OS] = getPlatformTitle(
              item[STATS_ADV_DATA.OS]
            );
          } else {
            newItem[STATS_ADV_DATA.OS] = "Unknown OS"
          }

          if (item[STATS_ADV_DATA.DEPARTMENT]) {
            newItem[STATS_ADV_DATA.DEPARTMENT] =
              DIRECTION_LABELS[item[STATS_ADV_DATA.DEPARTMENT]];
          }

          if (
            item[STATS_ADV_DATA.CLICKS] &&
            item[STATS_ADV_DATA.IMPRESSIONS] &&
            item[STATS_ADV_DATA.CLICKS] > 0 &&
            item[STATS_ADV_DATA.IMPRESSIONS] > 0
          ) {
            newItem[STATS_ADV_DATA.CTR] = `${(
              (item[STATS_ADV_DATA.CLICKS] / item[STATS_ADV_DATA.IMPRESSIONS]) *
              100
            ).toFixed(2)}%`;
          } else {
            newItem[STATS_ADV_DATA.CTR] = `${(0).toFixed(2)}%`;
          }

          if (item[STATS_ADV_DATA.REQUEST_VAR]) {
            const value = item[STATS_ADV_DATA.REQUEST_VAR].split("-").pop();
            if (value && Number(value) > 0) {
              newItem[STATS_ADV_DATA.REQUEST_VAR] = value;
            }
          }

          return newItem;
        }),
        totals,
      };
    });
  }

  exportAdvStatistic(query) {
    return NotixApiService.get("/stats/adv/export/", {
      params: getPreparedStatsAdvData(query),
    }).then((response) => {
      downloadFile(response.data || "", "stats.csv", FILE_TYPES.STREAM);
    });
  }

  loadPrometheus(id, type, period, step) {
    return NotixApi.post(`/stats/real-time`, {
      start: Dayjs().subtract(period, "minute").unix(),
      end: Dayjs().unix(),
      step,
      step_unit: "s",
      mailing_id: id,
      type,
    });
  }

  loadTotalPrometheus(id) {
    return NotixApi.get(`/stats/sending/total?mid=${id}`);
  }

  updateStats(pubId) {
    return NotixApi.get(`/stats/sync?pubId=${pubId}`);
  }
}

const statisticInstance = new Statistic();

export default statisticInstance;